<template>
  <div class="reachat needResize" :class="{'fullscreen': fullscreen}">
    <Info @fullscreen="onFullScreen" title="reachat.title" text="reachat.info" ></Info>
    <div class="title-reachat">
      <h3>{{$t('reachat.title')}}</h3>
    </div>
    <div  v-if="display">
      <div v-for="(progressBar, index) in progressBars">
        <ProgressBar :color="progressBar.color" :width="progressBar.width" :text="progressBar.text" :key="index"></ProgressBar>
      </div>
    </div>
    <div v-else>
      </br>
      {{$t('reachat.textWhenNoEndDate')}}
    </div>
  </div>
</template>

<script>
  import ProgressBar from './ProgressBar.vue'
  import Info from './Info.vue'
  export default {
    name: 'Reachat',
    components: {
      ProgressBar,
      Info
    },
    props: {
      index: Number, 
      result: Object
    },
    data() {
      return {
        fullscreen: false,
      }
    },
    computed: {
      display: function(){
        return this.result.aggregations.hasOwnProperty('nb_customers_m3')
      },
      progressBars: function(){
        let nbCustomersM3 = '0'
        let nbCustomersM6 = '0'
        let nbCustomersM12 = '0'
        let nbCustomersM24 = '0'
        let hits = this.result.hits ? this.result.hits.total : 0
        if (this.result && this.result.aggregations['nb_customers_m3'] && hits > 0) {

          nbCustomersM3 = (this.result.aggregations['nb_customers_m3'].doc_count * 100 / hits).toFixed(1)
          nbCustomersM6 = (this.result.aggregations['nb_customers_m6'].doc_count * 100 / hits).toFixed(1)
          nbCustomersM12 = (this.result.aggregations['nb_customers_m12'].doc_count * 100 / hits).toFixed(1)
          nbCustomersM24 = (this.result.aggregations['nb_customers_m24'].doc_count * 100 / hits).toFixed(1)
        }

        return [
          {
            color: "#A3A1FB",
            width: `${nbCustomersM3}%`,
            text: this.$t('reachat.nbCustomersM3Legend')
          },
          {
            color: "#5EE2A0",
            width: `${nbCustomersM6}%`,
            text: this.$t('reachat.nbCustomersM6Legend')
          },
          {
            color: "#FF6565",
            width: `${nbCustomersM12}%`,
            text: this.$t('reachat.nbCustomersM12Legend')
          },
          {
            color: "#FEC163",
            width: `${nbCustomersM24}%`,
            text: this.$t('reachat.nbCustomersM24Legend')
          }
        ]
      }
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/reachat.sass"
</style>
